import Text from 'components/Text';
import { formatCityStateZip } from 'features/report/pages/ReportPage/utils';
import React from 'react';
import shopSelectors from 'services/shop/selectors';
import { ICouponPrintDiscount } from 'services/shop/types/coupon';
import styled from 'styled-components';
import { PHONE_MASKED } from 'utils/mask';
import CouponDiscount from './coupon/Discount';

type IPrintBodyProps = {
  isPrinter?: boolean;
  billRef?: React.RefObject<HTMLDivElement>;
  coupons: ICouponPrintDiscount[];
};
const PrintBodyCouponOnly: React.FC<IPrintBodyProps> = ({ billRef, isPrinter, coupons }) => {
  const shopInfo = shopSelectors.data.shopInfo();

  const ThankYouData = () => {
    return (
      <FinalBox>
        <Text printMode variant="CONTENT_2" style={{ fontWeight: '500' }} >Powered by Fozito</Text>
      </FinalBox>
    );
  };

  return (
    <>
      <PrintBodyStyled id='receipt' className='PrintBodyCouponOnlyContainer'>
        <TicketBox ref={billRef} className='TicketBox'>
          <CountingBox>
            <div>
              <ShopText printMode variant="CONTENT_2" className='bold' style={{ fontSize: '1.5rem' }}>{shopInfo?.shopName || ''}</ShopText>
              <ShopText printMode variant="CONTENT_2" className={isPrinter ? 'bold' : ''}>
                {shopInfo?.address || ''}
              </ShopText>
              <ShopText printMode variant="CONTENT_2" className={isPrinter ? 'bold' : ''}>
                {formatCityStateZip(shopInfo?.city, shopInfo?.state, shopInfo?.zip)}
              </ShopText>
              <ShopText printMode variant="CONTENT_2" style={{ fontSize: '1.2rem' }}>
                {PHONE_MASKED.resolve(shopInfo?.phone || '')}
              </ShopText>
            </div>
          </CountingBox>
          <CouponDiscount data={coupons} />
          <ThankYouData />
        </TicketBox>
      </PrintBodyStyled>
    </>
  );
};

export default PrintBodyCouponOnly;
const PrintBodyStyled = styled.div`
  overflow: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 6rem;
  // justify-content: center;
  flex-grow: 1;
  .shop_name {
    color: black;
    text-align: right;
    font-family: 'Roboto', serif;
    font-size: 0.75rem;
    font-style: normal;
    font-weight: 700;
    line-height: 20px; /* 166.667% */
  }
  .shop_address, .shop_phone {
    color: black;
    font-family: 'Roboto', serif;
    text-align: right;
    font-size: 0.75rem;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
  }
  .customer_name {
    color: black;
    font-family: 'Roboto', serif;
    font-size: 1.25rem;
  }
`;
const TicketBox = styled.div`
  border-radius: 20px;
  background: #fff;
  width: 25.5rem;
  height: fit-content;
`;

const CountingBox = styled.div`
`;

const ShopText = styled(Text)`
  color: black;
  font-style: normal;
  font-family: 'Roboto', serif;
  font-size: 1rem;
  font-style: normal;
  font-weight: bold;
  line-height: 20px;
  text-align: center;

  &.bold {
    font-size: 1rem;
    font-weight: 700;
  }
`;

const FinalBox = styled.div<{ border?: boolean }>`
  padding: 0;
  text-align: center;
  font-weight: 400;
  .bold {
    font-weight: 500;
  }
  ${({ border }) => border && `
    margin-top: 1rem;
    padding-top: 0.5rem;
    margin-right: 1rem;
    margin-left: 1rem;
    border-top: 1px solid black;
  `}
`;
